import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import { auth } from './firebaseConfig.js';
import { firestorePlugin } from 'vuefire';
import vuetify from './plugins/vuetify';
import '@babel/polyfill';
Vue.use(firestorePlugin);

Vue.config.productionTip = false;

let app;
auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app');
  }
});
